import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Page from '../index'
import Toggle from '../../components/Toggle'

import { setNewStylesThemeEnabled } from '../../modules/actions/app'
import { isNewStylesThemeEnabledSelector } from '../../modules/selectors/app'

function ThemeSelector() {
  const dispatch = useDispatch()
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)

  const [isEnabled, setIsEnabled] = useState(isNewStylesThemeEnabled)

  return (
    <Page helmetTitle="Theme Selector" showPartnershipInfo={false}>
      <h3>Is new theme enabled?</h3>
      <br />
      <Toggle
        isEnabled={isEnabled}
        onToggle={() => {
          setIsEnabled(!isEnabled)
          dispatch(setNewStylesThemeEnabled(!isEnabled))
        }}
        isBig={true}
      />
      <br />
      <div>
        Current theme - <strong>{isEnabled ? 'new' : 'legacy'}</strong>
      </div>
    </Page>
  )
}

export default ThemeSelector
